import { render } from "./process_list_id.vue?vue&type=template&id=53e4d7d6&scoped=true"
import script from "./process_list_id.vue?vue&type=script&lang=js"
export * from "./process_list_id.vue?vue&type=script&lang=js"

import "./process_list_id.vue?vue&type=style&index=0&id=53e4d7d6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53e4d7d6"]])

export default __exports__